type MainStoreakeSelectOptions = {
  value: 'value' | string;
  label: 'label' | string;
};

export function makeSelectOption(
  data: string,
  { value, label }: MainStoreakeSelectOptions = { value: 'value', label: 'label' }
) {
  return { [value]: data, [label]: data };
}

export function makeSelectOptions(
  data: string[],
  { value, label }: MainStoreakeSelectOptions = { value: 'value', label: 'label' }
) {
  return data.map((item) => makeSelectOption(item, { value, label }));
}
